<template>
	<div class="grid">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-map-marker"></i>
				</span>
				<span class="overview-title">Selección de comedor</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">Para operar en el sistema debe seleccionar el comedor donde está entregando viandas y la parada en la que se encuentra.</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Toast/>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-md-6">
                            <Fieldset legend="Datos del usuario">
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Nombre:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{nombrepersona}}
                                    </div>
                                </div>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Cédula de Identidad:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{cipersona}}
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <div>
                                <label for="moviles">Punto donde se está cumpliendo funciones</label>
                                <Dropdown id="moviles" v-model="movil" :options="moviles" optionLabel="ComNombre" optionValue="ComId" placeholder="Seleccionar" 
                                autofocus :class="{'p-invalid': submittedMovil && !movil}" @change="onchangeMovil()" :loading="loadingmovil"/>
                                <small class="p-invalid" v-if="submittedMovil && !movil">Se requiere seleccionar un lugar.</small>
                            </div>
                            <div class="p-mt-5">
                                <label for="paradas">Parada donde se está operando</label>
                                <Dropdown id="paradas" v-model="parada" :options="paradas" optionLabel="ParNom" optionValue="ParId" placeholder="Seleccionar" emptyMessage="No disponible hasta elegir Comedor" 
                                autofocus :class="{'p-invalid': submittedParada && !parada}" @change="onChangeParada()" :loading="loadingparada"/>
                                <small class="p-invalid" v-if="submittedParada && !parada">Se requiere seleccionar una parada.</small>
                            </div>
                        </div>
                    </div>
                   
                    <Toolbar>
                        <template v-slot:left>
                            
                        </template>

                        <template v-slot:right>
                            <Button label="Elegir" @click="elegir()" icon="pi pi-angle-right" iconPos="left"/>
                        </template>
                    </Toolbar>
				</div> 
			</div>
		</div>
	</div>		
</template>

<script>
import SmartService from '../service/SmartService';
export default {
	data() {
		return {
            wait: false,
            nombrepersona: "",
			cipersona: "",
            movil: null,
            parada: null,
            submittedMovil: false,
            submittedParada: false,
            loadingmovil: false,
            loadingparada: false,
            moviles:[],
            paradas:[],
		}
	},	
	smartService: null,
	created() {
        this.smartService = new SmartService();
	},

	mounted() {
        this.loadMoviles();
        this.cargarDatos();
	},

	methods: {
        async loadMoviles(){
            this.loadingmovil = true,
            this.smartService.getComedores().then(data => { 
            this.loadingmovil = false;
            this.moviles = data;
            //this.moviles = this.moviles.filter(lugar => lugar.ComMovil === true);
            //QUITAR
            /* this.movil = 13;
            this.onchangeMovil(); */
            if (localStorage.movil_id && localStorage.parada_id){
                this.movil = Number(localStorage.movil_id);
                this.loadParada();
            }
            })
        },

        loadParada(){
            this.loadingparada = true;
            this.smartService.getParadas(this.movil).then(data => {
                this.paradas = data;
                this.loadingparada = false;
                this.parada = Number(localStorage.parada_id);
            });
        },

        onchangeMovil(){
            if (this.movil != null){
                    this.loadingparada = true;
					this.smartService.getParadas(this.movil).then(data => {
                        this.paradas = data;
                        this.parada = null;
                        this.loadingparada = false;
                        //QUITAR
                        /* this.parada = 7;
                        this.variableGlobal(); */
                    });
			}
        },

        onChangeParada(){

        },


        elegir(){
            this.variableGlobal();
        },

        async cargarDatos() {
			this.wait= true;
			if (localStorage.nombre){
				this.nombrepersona= localStorage.nombre;
				this.cipersona= localStorage.cedula;
			}
			this.wait= false;
		},

        variableGlobal() {
			this.submittedMovil = true;
            this.submittedParada = true;
			if (this.movil && this.parada) {
                localStorage.movil_id = this.movil;
                localStorage.parada_id = this.parada;
                let aux1 = this.moviles.find(aux1 => aux1.ComId === this.movil);
                let aux2 = this.paradas.find(aux2 => aux2.ParId === this.parada);
                localStorage.movil_name = aux1.ComNombre;
                localStorage.parada_name = aux2.ParNom;
                //Me fijo si es comedor tradicional
                if (aux1.ComMovil == false){
                    localStorage.multiplicador = 1;
                    localStorage.esMovil = 0;
                }
                else {
                    localStorage.esMovil = 1;
                }
                this.$toast.add({severity:'success', summary: 'Lugar seleccionado', detail:'Se eligió el lugar donde entregará viandas.', life: 3000});
			}
		},
	},
}
</script>

<style scoped lang="scss">
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>